type SortInput = { field: string; order: string }

export type GetQueryInput = {
  pagination?: {
    page?: number
    per_page?: number
    perPage?: number
  }
  sort?: SortInput | SortInput[]
  filter?: Record<string, unknown>
  params?: Record<string, unknown>
}

export type GetQueryResult = {
  page: number
  per_page: number
  q: Record<string, unknown> & { s: string | string[] }
}

const PAGINATION_DEFAULT_PAGE = 1
const PAGINATION_DEFAULT_PER_PAGE = 12

/**
 * Converte o estado do `ResourceRecordsContext` para o formato que a API Rails
 * espera (`page`, `per_page`, `q[s]` via Ransack).
 */
export const getQuery = (query: GetQueryInput = {}): GetQueryResult => {
  const { pagination = {}, sort, filter = {}, params = {}, ...rest } = query
  const { page, per_page, perPage } = pagination

  return {
    page: page || PAGINATION_DEFAULT_PAGE,
    per_page: per_page || perPage || PAGINATION_DEFAULT_PER_PAGE,
    q: {
      ...filter,
      s: sort
        ? Array.isArray(sort)
          ? sort.map(item => `${item.field} ${item.order}`)
          : `${sort.field} ${sort.order}`
        : 'created_at desc'
    },
    ...params,
    ...rest
  }
}
